import React from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { actions } from "./snackbarRedux";
import {
  Snackbar,
  SnackbarContent,
  IconButton,
  makeStyles,
  colors,
} from "@material-ui/core";
import clsx from "clsx";
import { Close, CheckCircle, Warning, Error, Info } from "@material-ui/icons";

const { hideSnackbar } = actions;

const iconVariants = {
  success: CheckCircle,
  warning: Warning,
  error: Error,
  info: Info,
};

const { green, amber } = colors;

const useStyles = makeStyles((theme) => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: "flex",
    alignItems: "center",
  },
}));

export default function SnackbarLayout({ children }) {
  const { showSnackbar, snackbarType, snackbarMessage } = useSelector(
    ({ snackbar }) => ({
      showSnackbar: snackbar.showSnackbar,
      snackbarType: snackbar.snackbarType,
      snackbarMessage: snackbar.snackbarMessage,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  const classes = useStyles();
  function onClose() {
    dispatch(hideSnackbar());
  }

  const Icon = iconVariants[snackbarType];

  return (
    <>
      {children}
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={showSnackbar}
        autoHideDuration={6000}
        onClose={onClose}
      >
        <SnackbarContent
          className={clsx(classes[snackbarType])}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className={classes.message}>
              <Icon className={clsx(classes.icon, classes.iconVariant)} />
              {snackbarMessage}
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={onClose}
            >
              <Close className={classes.icon} />
            </IconButton>,
          ]}
        />
      </Snackbar>
    </>
  );
}
